import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiTableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableRow from '@mui/material/TableRow';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useCallback, useEffect } from 'react';
import { useSTColumns, useSTRows } from '../SmartTableContext';
import { TableBodyRow } from './TableBodyRow';
const estimateSize = () => 30;
const overscan = 10;
const useOnScrollEffect = (loadRange, from, to, maxOffset) => useEffect(() => {
    loadRange({
        offset: Math.min(maxOffset ?? Number.MAX_SAFE_INTEGER, from),
        pageSize: Math.max(0, to - from),
        maxOffset: maxOffset ?? undefined,
    });
}, [from, loadRange, maxOffset, to]);
export function TableBody({ tableContainerEl }) {
    const getScrollElement = useCallback(() => tableContainerEl, [tableContainerEl]);
    const { rows, rowsCount, loadRowsRange, rowsFilterCondition } = useSTRows();
    const { visibleColumns } = useSTColumns();
    const rowVirtualizer = useVirtualizer({
        getScrollElement,
        count: rowsCount,
        overscan,
        estimateSize,
    });
    useOnScrollEffect(loadRowsRange, rowVirtualizer.range.startIndex - overscan, rowVirtualizer.range.endIndex + overscan, rowsFilterCondition?.maxRecords);
    const virtualRows = rowVirtualizer.getVirtualItems();
    const totalSize = rowVirtualizer.getTotalSize();
    const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0;
    const paddingBottom = virtualRows.length > 0 ? totalSize - (virtualRows?.[virtualRows.length - 1]?.end || 0) : 0;
    return (_jsxs(MuiTableBody, { children: [paddingTop > 0 && (_jsx(MuiTableRow, { children: _jsx(MuiTableCell, { style: { height: `${paddingTop}px` } }) })), virtualRows.map((virtualRow, index) => {
                const row = rows[virtualRow.index];
                return _jsx(TableBodyRow, { row: row, virtualRow: virtualRow, columns: visibleColumns }, index);
            }), paddingBottom > 0 && (_jsx(MuiTableRow, { children: _jsx(MuiTableCell, { style: { height: `${paddingBottom}px` } }) }))] }));
}
//# sourceMappingURL=TableBody.js.map